import { classnames } from '@/libs/utils';
import Icon from '@/components/atoms/Icon';
import TooltipV2 from '@/components/TooltipV2';

export default function MultiSelectFooter({
  selectedCount,
  onCancel,
  onDelete,
  onDownload,
  isDownloadDisabled = false
}: {
  selectedCount: number;
  onCancel: () => void;
  onDelete: () => void;
  onDownload: () => void;
  isDownloadDisabled?: boolean;
}) {
  const hasSelection = selectedCount > 0;

  return (
    <div className="flex items-center justify-between">
      <button className="text-sm font-medium text-slate-600 hover:text-slate-900" onClick={onCancel}>
        Cancel
      </button>
      <div className="flex items-center space-x-2">
        <button
          disabled={!hasSelection}
          onClick={onDelete}
          className={classnames(
            'flex items-center space-x-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
            hasSelection ? 'text-red-600 hover:bg-red-50' : 'cursor-not-allowed text-slate-300'
          )}
        >
          <Icon name="IconTrash" size={16} />
          <span>Delete</span>
        </button>
        <TooltipV2
          tooltipId="multi-select-download-tooltip"
          tooltipContent={isDownloadDisabled ? 'None of the selected clips are ready to download' : ''}
          tooltipElement={
            <button
              disabled={!hasSelection || isDownloadDisabled}
              onClick={onDownload}
              className={classnames(
                'flex items-center space-x-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
                hasSelection && !isDownloadDisabled
                  ? 'bg-slate-900 text-white hover:bg-slate-700'
                  : 'cursor-not-allowed bg-slate-100 text-slate-400'
              )}
            >
              <Icon name="IconDownload" size={16} />
              <span>Download</span>
            </button>
          }
        />
      </div>
    </div>
  );
}
